import { supabase } from "../lib/api";

export const getUserLikedLinks = async (userLikedLinks: number[]) => {
  return await supabase
    .from("links")
    .select("*")
    .in("id", userLikedLinks)
    .order("created_at", { ascending: false });
};
